import { theme, VerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

export const Ul = styled.ul`
  padding: 0 0 0 1em;
  margin: 1.5em 0;
`

export const WhatYoullLearnWrapper = styled(VerticalSpacer)`
  > *:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.GREY_30};
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
`
